module.exports = __webpack_public_path__ + "img/credit-card-error.a5f806ff.svg";